import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../styles/colors';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import { BlockInfo } from '../containers/Blocks';

const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

export default class BlockPreviewBtn extends Component {
    state = {
        open: false
    };
    render() {
        const { block } = this.props;
        const { open } = this.state;
        return (
            <div>
                <Dialog onClose={() => this.setState({ open: false })} aria-labelledby="customized-dialog-title" open={open}>
                    <DialogTitle id="customized-dialog-title" onClose={() => this.setState({ open: false })}>
                        Preview
                </DialogTitle>
                    <DialogContent dividers>
                        <Typography gutterBottom component="span">
                            <div className="modalBody modal-content" style={{ width: 320 }}>
                                <BlockInfo blockId={block._id} />
                            </div>
                        </Typography>
                    </DialogContent>
                </Dialog>
                <span
                    className="link"
                    onClick={() => this.setState({ open: true })}
                    style={{ float: 'right' }}>
                    <FontAwesomeIcon icon="eye" title={'Preview'}
                        style={{ marginRight: 5, color: COLORS.orange }} />
                </span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/BlockPreviewBtn.js